import React, { useEffect } from 'react';
import './psbienmas.css';
import { psbienmas } from '../../json/psbienmas';

const Psbienmas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Bienestar de Madres Solteras</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
               
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El programa está dirigido a mujeres que trabajen en el sector formal o que estudien, brindándoles un apoyo económico bimestral que será destinado al cuidado y atención de sus hijos, de 0 hasta 4 años 11 meses de edad, con la finalidad de apoyar a estas mujeres a permanecer o poder acceder a mejores oportunidades laborales y de superación académica, al contar con recursos para destinar al pago de una persona responsable para el cuidado y atención infantil.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar las condiciones para el acceso y permanencia en el mercado laboral y en los estudios de las Madres Solteras que no cuenten con la prestación de cuidados infantiles, de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Madres Solteras que trabajen en el sector formal y madres estudiantes con hijo o hija de 0 a 4 años y 11 meses, sin acceso a los servicios de cuidado y atención infantil que perciban un ingreso comprobable menor a los $6,500. 00 (Seis mil quinientos pesos 00/100) de manera mensual.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                El Programa “Bienestar de Madres Solteras”, priorizará la distribución equitativa de los apoyos en las 12 regiones del Estado de Hidalgo, de acuerdo con el Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Inclusión y Desarrollo<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Ing. Julián Nochebuena Hernández<br />                    
                  </li>
                  <li>Lic. Francisco Alberto Rico Romo<br />
                  </li>
                  <li>Ing. Juan Roberto Lazcano Trejo<br />
                  </li>
                  <li>Lic. Rosa Isela Ramírez Romero<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 717 8000 Ext. 8948, 8950, 8933, 8538
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_Madres_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2023/Conv_MadresSolteras_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Convocatoria</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Folios_Beneficiarios_Bien_y_Des_Madres_Solt.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/folios/2023/Folios_MadresSolteras2829sep23.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                //href='transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Padrón_Benef_M_Solteras.pdf'
                //target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                ></a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/indicadores/2023/Est_MadrsSolt.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Estadisticas</a></strong></h5>

                
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psbienmas;